var _excluded = ["badge", "disabled", "label", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Tab = function Tab(_ref) {
  var badge = _ref.badge,
    disabled = _ref.disabled,
    label = _ref.label,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return ___EmotionJSX("div", _extends({
    badge: badge,
    disabled: disabled,
    label: label
  }, props), children);
};
Tab.propTypes = {
  badge: PropTypes.shape({
    status: PropTypes.oneOf(['notification', 'warning']),
    text: PropTypes.string
  }),
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
export default Tab;